











































































































import { Component, Emit, Prop } from 'vue-property-decorator';
import Super from '@/Super';
import Modal from '../Modal.vue';
import { Resource } from '@/data/resource.interface';

@Component({
  components: {
    Modal
  }
})
export default class ResourceListModal extends Super {
  @Prop() visible!: boolean;
  @Prop() title!: string;
  @Prop() resources!: Resource[];

  @Emit()
  close() {}

  viewResource(item: Resource) {
    switch (item.type) {
      case 'pdf': this.openPDF(item.title, item.url); break;
      case 'video': this.openVideo(item.title, item.url); break;
    }
  }
}
